import React from 'react';
import '../../../assets/sass/global/export/export.scss';

export default React.forwardRef((props, ref) => (
        <section className="pdf-container">
            <section className="pdf-content" ref={ref}>
                {props.children}
            </section>
        </section>
    )
);
